// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css' // 自定义图标
// 国际化
import i18n from './i18n/i18n'
import VueStorage from 'vue-ls'
import App from './App'
import router from './router'
import store from './store'
import _ from 'lodash'
// import $ from 'jquery'
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(_)
Vue.use(VueStorage, {
  namespace: 'fore__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local' // storage name session, local, memory
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js